export default {
  fields: {
    country: 'Land der Bank',
    iban: 'IBAN',
    routing_number: 'Routing-Nummer',
    account_number: 'Kontonummer',
    sort_code: 'Sort Code',
    account_type: 'Kontoart',
  },
  help: {
    country: 'Das Land der Bank, das vom Land des Restaurants abweichen kann.',
  },
  placeholders: {
    iban: 'DE89 3704 0044 0532 0130 00',
  },
  formats: {
    uk_local: {
      title: 'Sort Code und Kontonummer',
      description: 'Die übliche Angabe für ein britisches Konto.',
    },
    iban: {
      title: 'IBAN',
      description: 'Die internationale Kontonummer.',
    },
    us_local: {
      title: 'Routing- und Kontonummer',
      description: 'Ein Bankkonto in den USA.',
    },
  },
  account_types: {
    checking: 'Girokonto',
    savings: 'Sparkonto',
  },
  actions: {
    save: 'Bankkonto speichern',
    cancel: 'Abbrechen',
    edit: 'Bearbeiten',
  },
  card: {
    account: 'Konto',
    country: 'Land',
    status: 'Status',
  },
  statuses: {
    active: 'Aktiv',
    pending_verification: 'Wird geprüft',
    action_needed: 'Handlungsbedarf',
    errored: 'Auszahlung fehlgeschlagen',
    missing: 'Fehlt',
  },
  notes: {
    pending_verification:
      'Adyen prüft jedes Bankkonto, bevor Auszahlungen beginnen. Bestätigen Sie es auf der Seite von Adyen per Bank-Login oder Kontoauszug.',
    action_needed:
      'Der Zahlungsanbieter konnte dieses Bankkonto nicht bestätigen. Prüfen Sie die Angaben oder hinterlegen Sie ein anderes Konto.',
    errored:
      'Eine Auszahlung auf dieses Konto ist fehlgeschlagen, Auszahlungen sind pausiert. Prüfen Sie die Angaben oder hinterlegen Sie ein anderes Konto.',
  },
};
